import React, { useState, useEffect } from 'react'
import Select from 'react-select'
import { CButton, CCard, CCardBody, CModal, CModalHeader, CModalTitle, CModalBody, CModalFooter, CFormLabel, CFormInput, CSpinner, CNav, CNavItem, CNavLink, CCardHeader, CCardTitle, CCardText, CCol, CRow, CFormTextarea, CTabContent, CTabPane } from '@coreui/react'
import { CircleAlertIcon, Pencil, Trash2, ListOrdered, Info, AlignLeft, CirclePlus } from 'lucide-react'
import GetDiagnosisData from '../../services/general/getDiagnosisData.api'
import Pageloader from '../../components/shared/Pageloader'
import Accordions from '../../components/shared/Accordians'
import AccordianEditDelete from '../../components/shared/AccordianEditDelete'
import SaveExtra from '../../services/general/saveExtraData.api'
import toast from 'react-hot-toast'
import { toastConfig } from '../../constants/other.config'
import DifferentialSuggestion from './DifferentialSuggestion'
import ListView from '../../components/shared/ListView'
import AddSuggestionTitle from './AddSuggestionTitle'
import { motion } from 'framer-motion'
import AddCopyStatement from '../../components/shared/AddCopyStatement'
import DifferentialCopy from './DifferentialCopy'

const Generalplanstatements = ({ LinkFor = 'generalPlanStatements' }) => {
  const [diagnosisData, setDiagnosisData] = useState([])
  const [modalVisible, setModalVisible] = useState(false)
  const [suggestionModalVisible, setSuggestionModalVisible] = useState(false)
  const [isEditing, setIsEditing] = useState(false)
  const [currentDiagnosisId, setCurrentDiagnosisId] = useState(null)
  const [selectedDiagnosis, setSelectedDiagnosis] = useState(null)
  const [diagnosisOptions, setDiagnosisOptions] = useState([])
  const [assessment, setAssessment] = useState([])
  const [plans, setPlans] = useState([])
  const [isLoading, setIsLoading] = useState(false)
  const [deleteVisibleId, setDeleteVisibleId] = useState(null)
  const [isPageLoading, setIsPageLoading] = useState(false)
  const [showEditModal, setShowEditModal] = useState(false)
  const [deleteModal, setDeleteModal] = useState(false)
  const [activeTab, setActiveTab] = useState(0)
  const [suggestionId, setSuggestionId] = useState(null)
  const [accordions, setAccordions] = useState([])
  const [currentParentId, setCurrentParentId] = useState(null)
  const [newTitle, setNewTitle] = useState('')
  const [suggestionTitle, setSuggestionTitle] = useState([])
  const [editMode, setEditMode] = useState(false)
  const [editingAccordionId, setEditingAccordionId] = useState(null)
  const [suggestionData, setSuggestionData] = useState([])
  const [suggestionIndex, setSuggestionIndex] = useState(null)
  const [saveResoanChange, setSaveResoanChange] = useState({})
  const [submitDescription, setSubmitDescription] = useState(false)
  const [activeDescriptions, setActiveDescriptions] = useState(null)
  const [fileStatmentData, setFileStatmentData] = useState({
    attachedIndex: '',
    parentId: '',
    name: '',
  })

  const [file, setFile] = useState([])
  const [showTitleFooter, setShowTitleFooter] = useState(true)

  const saveToLocalStorage = (data) => {
    // localStorage.setItem('SuggestionDiagnosis', JSON.stringify(data));
  }

  useEffect(() => {
    if (selectedDiagnosis) {
      let result = suggestionData.filter((item) => item?.Data.diagnosis.value === selectedDiagnosis?.value)

      let resultData = result.length > 0 ? result[0].Data : null
      const newAccordion = {
        id: Date.now(),
        title: selectedDiagnosis.label,
        description: '',
        // suggestions: [],
        suggestions: {
          suggestionName: [],
          orders: [],
          planSuggestions: [],
          information: [],
        },
        children: [],
      }

      if (result.length > 0) {
        if (resultData?.accordions.length === 0) {
          setAccordions({ ...resultData, accordions: [newAccordion] })
        } else {
          setAccordions(result[0].Data)
        }
      } else {
        setAccordions({ diagnosis: selectedDiagnosis || null, accordions: [newAccordion] })
      }
    }
  }, [selectedDiagnosis])

  const addAccordion = (parentId = null) => {
    if (editMode) {
      setAccordions((prev) => {
        const updatedAccordions = updateAccordionTitle(prev.accordions, editingAccordionId, newTitle)
        const updatedData = { ...prev, accordions: updatedAccordions }
        saveToLocalStorage(updatedData)
        return updatedData
      })
    } else {
      const newAccordion = {
        id: Date.now(),
        title: newTitle,
        description: '',
        suggestions: {
          suggestionName: [],
          orders: [],
          planSuggestions: [],
          information: [],
        },
        children: [],
      }

      setAccordions((prev) => {
        const updatedAccordions = parentId ? updateNestedAccordions(prev.accordions, parentId, newAccordion) : [...prev?.accordions, newAccordion]

        const updatedData = { ...prev, accordions: updatedAccordions }
        saveToLocalStorage(updatedData)
        return updatedData
      })
    }

    closeModal()
  }

  const updateAccordionTitle = (list, accordionId, newTitle) => list.map((item) => (item.id === accordionId ? { ...item, title: newTitle } : { ...item, children: updateAccordionTitle(item.children, accordionId, newTitle) }))

  const updateNestedAccordions = (list, parentId, newAccordion) => list.map((item) => (item.id === parentId ? { ...item, children: [...item.children, newAccordion] } : { ...item, children: updateNestedAccordions(item.children, parentId, newAccordion) }))

  const editAccordion = (accordionId, currentTitle) => {
    setEditMode(true)
    setEditingAccordionId(accordionId)
    setNewTitle(currentTitle)
    setModalVisible(true)
  }

  // const addSuggestion = (parentId) => {

  //     let suggestionText = suggestionTitle;

  //     if (suggestionText) {
  //         setAccordions((prev) => {
  //             const updatedSuggestions = updateNestedSuggestions(prev.accordions, parentId, suggestionText);
  //             const updatedData = { ...prev, accordions: updatedSuggestions };
  //             saveToLocalStorage(updatedData);
  //             return updatedData;
  //         });
  //     }
  //     setSuggestionTitle([])
  //     setSuggestionModalVisible(false)
  // };

  const addSuggestion = (parentId = null) => {
    let suggestionText = suggestionTitle

    if (suggestionText) {
      setAccordions((prev) => {
        let updatedAccordions = prev.accordions
        if (!updatedAccordions || updatedAccordions.length === 0) {
          const newAccordion = {
            id: Date.now(),
            title: null,
            suggestions: {
              suggestionName: suggestionText,
              orders: [],
              planSuggestions: [],
              information: [],
            },
            children: [],
          }
          updatedAccordions = [newAccordion]
        } else {
          updatedAccordions = updateNestedSuggestions(updatedAccordions, parentId, suggestionText)
        }

        const updatedData = { ...prev, accordions: updatedAccordions }
        saveToLocalStorage(updatedData)
        return updatedData
      })
    }
    setSuggestionTitle([])
    setSuggestionModalVisible(false)
  }

  const updateNestedSuggestions = (list, parentId, suggestion) =>
    list.map((item) =>
      item.id === parentId
        ? {
            ...item,
            suggestions: {
              ...item.suggestions,
              suggestionName: suggestion,
              orders: [],
              planSuggestions: [],
              information: [],
            },
          }
        : {
            ...item,
            children: updateNestedSuggestions(item.children, parentId, suggestion),
          },
    )

  const openModal = (parentId = null) => {
    setCurrentParentId(parentId)
    setModalVisible(true)
  }

  const closeModal = () => {
    setModalVisible(false)
    setNewTitle('')
    setEditingAccordionId(null)
    setEditMode(false)
  }

  const deleteAccordion = (parentId) => {
    setDeleteVisibleId(parentId)
  }

  const removeAccordionById = (list, accordionId) =>
    list
      .filter((item) => item.id !== accordionId)
      .map((item) => ({
        ...item,
        children: removeAccordionById(item.children, accordionId),
      }))

  const handelSubmit = async (shouldClose = true) => {
    setIsLoading(true)
    try {
      if (!selectedDiagnosis) {
        alert('Please select a diagnosis.')
        return
      }
      let localData = JSON.parse(localStorage.getItem('SuggestionDiagnosis')) || []

      let SuggestionData = suggestionData.filter((item) => item?.Data?.diagnosis?.value === selectedDiagnosis.value)
      if (SuggestionData.length > 0) {
        await SaveExtra('Update', 'generalPlanStatements', JSON.stringify(accordions), SuggestionData[0].Id)
        toast.success('Saved', toastConfig)
      } else {
        await SaveExtra('Insert', 'generalPlanStatements', JSON.stringify(accordions))
        toast.success('Saved', toastConfig)
      }

      if (shouldClose) {
        setModalVisible(false)
      }
      setSaveResoanChange({})
      getData()
    } catch (error) {
      console.log(error)
    } finally {
      setIsLoading(false)
    }
  }

  const getData = async () => {
    setIsPageLoading(true)
    try {
      let response = await GetDiagnosisData('')
      let diagnosis = JSON.parse(response.d)?.Data

      let localData = JSON.parse(localStorage.getItem('SuggestionDiagnosis')) || []

      // setSuggestionData(localData)
      // let responseRisks = await GetDiagnosisData("Risks");
      // let localData = JSON.parse(responseRisks.d)?.Data;

      let data = await SaveExtra('Get_By_Type', 'generalPlanStatements', '', '')
      data = JSON.parse(data.d)?.Data || []
      if (data) {
        data = data?.map((item) => {
          return {
            Id: item.Id,
            Data: JSON.parse(item?.JsonData),
          }
        })
      }

      setSuggestionData(data)
      updateDiagnosisOptions(diagnosis)
    } catch (error) {
      console.log(error)
    } finally {
      setIsPageLoading(false)
    }
  }

  const updateDiagnosisOptions = (data) => {
    const options = data
      .sort((a, b) => a.Name.trim().localeCompare(b.Name.trim()))
      .map((item) => ({
        value: item.id,
        label: item.Name,
      }))

    setDiagnosisOptions(options)
  }

  useEffect(() => {
    getData()
  }, [])

  const editSuggestion = (parentId, suggestionIndex) => {
    const newSuggestion = suggestionTitle
    if (newSuggestion) {
      setAccordions((prev) => {
        const updatedSuggestions = updateEditNestedSuggestions(prev.accordions, parentId, suggestionIndex, newSuggestion)
        const updatedData = { ...prev, accordions: updatedSuggestions }
        saveToLocalStorage(updatedData)
        return updatedData
      })
    }
    setSuggestionTitle([])
    setEditMode(false)
    setSuggestionModalVisible(false)
    setSuggestionIndex(null)
  }

  const updateEditNestedSuggestions = (list, parentId, suggestionIndex, newSuggestion) =>
    list.map((item) =>
      item.id === parentId
        ? {
            ...item,
            suggestions: {
              ...item.suggestions,
              suggestionName: newSuggestion,
            },
          }
        : {
            ...item,
            children: item.children ? updateEditNestedSuggestions(item.children, parentId, suggestionIndex, newSuggestion) : item.children,
          },
    )

  const handleSuggestionsChange = (updatedSuggestions, parentId) => {
    setAccordions((prev) => {
      const updatedData = {
        ...prev,
        accordions: updateNestedSuggestionsResoan(prev.accordions, parentId, updatedSuggestions),
      }
      return updatedData
    })
  }

  const updateNestedSuggestionsResoan = (list, parentId, updatedSuggestions) =>
    list.map((item) =>
      item.id === parentId
        ? { ...item, suggestions: { ...item.suggestions, orders: updatedSuggestions } }
        : {
            ...item,
            children: updateNestedSuggestionsResoan(item.children || [], parentId, updatedSuggestions),
          },
    )

  const [titleDescriptionId, setTitleDescriptionId] = useState('')
  const [descriptionText, setDescriptionText] = useState('')

  const handleAddTitleDescription = (item) => {
    setDescriptionText(item.description)
    setTitleDescriptionId(item.id)
  }

  const handleSaveDescription = () => {
    try {
      const updateDescriptionInNestedChildren = (data, id, descriptionText) => {
        if (!data || !Array.isArray(data)) {
          return false
        }

        for (const item of data) {
          if (item.id === id) {
            item.description = descriptionText
            return true
          }
          if (item.children && Array.isArray(item.children)) {
            const updated = updateDescriptionInNestedChildren(item.children, id, descriptionText)
            if (updated) return true
          }
        }
        return false // Not found
      }

      let updated = false
      if (accordions?.accordions) {
        updated = updateDescriptionInNestedChildren(accordions.accordions, titleDescriptionId, descriptionText)
      }

      if (updated) {
        toast.success('Description Saved', toastConfig)
      } else {
        console.log('Item not found.')
      }

      // setDescriptionText("")
      // setTitleDescriptionId('');
    } catch (error) {
      console.log(error)
    }
  }

  const [descriptionStatementId, setDescriptionStatementId] = useState({
    orderIndex: '',
    parentId: '',
    name: '',
  })

  const [showDescriptionStatementModal, setShowDescriptionStatementModal] = useState(false)
  const [descriptionStatementText, setDescriptionStatementText] = useState('')

  const handleAddStatementDescription = (item, descriptionText) => {
    setShowDescriptionStatementModal(true)
    setDescriptionStatementId(item)
    setDescriptionStatementText(descriptionText)
  }

  const handleDescriptionStatementSubmit = () => {
    const updateNestedAccordion = (accordionList) => {
      return accordionList.map((accordion) => {
        if (accordion.id === descriptionStatementId.parentId) {
          const updatedSuggestionName = [...accordion.suggestions.suggestionName]

          // Update the `description` in `suggestionName` based on `name`
          updatedSuggestionName.forEach((suggestion) => {
            if (suggestion.name === descriptionStatementId.name) {
              suggestion.description = descriptionStatementText
            }
          })

          return {
            ...accordion,
            suggestions: {
              ...accordion.suggestions,
              suggestionName: updatedSuggestionName,
            },
          }
        }

        if (accordion.children && accordion.children.length > 0) {
          return {
            ...accordion,
            children: updateNestedAccordion(accordion.children),
          }
        }

        return accordion
      })
    }

    const updatedAccordions = updateNestedAccordion(accordions.accordions)

    // Update the state
    accordions.accordions = updatedAccordions
    toast.success('Description Saved', toastConfig)
    // Reset the modal and fields
    // setDescriptionStatementId({
    //     name: "",
    //     parentId: "",
    // });
  }

  const handleTitleParentMediaId = (parentId) => {
    setCurrentParentId(parentId)
  }

  const handleTitleFileSave = (deleteFile = null) => {
    setAccordions((prevData) => {
      const updateAttachment = (data, files) =>
        data?.map((item) =>
          item.id === currentParentId
            ? {
                ...item,
                attached: {
                  image: [...(item.attached?.image ?? []).filter((f) => f.url !== deleteFile), ...files.filter((f) => f.type === 'image' && !(item.attached?.image ?? []).some((existing) => existing.url === f.url)).map((f) => ({ url: f.url, fileName: f.fileName, publicId: f?.publicId, id: f?.id }))],

                  video: [...(item.attached?.video ?? []).filter((f) => f.url !== deleteFile), ...files.filter((f) => f.type === 'video' && !(item.attached?.video ?? []).some((existing) => existing.url === f.url)).map((f) => ({ url: f.url, fileName: f.fileName, publicId: f?.publicId, id: f?.id }))],

                  document: [
                    ...(item.attached?.document ?? []).filter((f) => f.url !== deleteFile),
                    ...files.filter((f) => f.type !== 'image' && f.type !== 'video' && !(item.attached?.document ?? []).some((existing) => existing.url === f.url)).map((f) => ({ url: f.url, fileName: f.fileName, publicId: f?.publicId, id: f?.id })),
                  ],
                },
              }
            : { ...item, children: updateAttachment(item.children, files) },
        ) ?? data

      return prevData?.accordions ? { ...prevData, accordions: updateAttachment(prevData.accordions, file) } : (console.log('Item not found.'), prevData)
    })
  }

  const handleFileStatementData = (item) => {
    setFileStatmentData(item)
  }
  const handleStatementFileSave = (deleteFile = null) => {
    setAccordions((prevData) => {
      const updateNestedAccordion = (accordionList) =>
        accordionList?.map((accordion) =>
          accordion.id === fileStatmentData.parentId
            ? {
                ...accordion,
                suggestions: {
                  ...accordion.suggestions,
                  suggestionName: accordion.suggestions.suggestionName.map((suggestion) =>
                    suggestion.name === fileStatmentData.name
                      ? {
                          ...suggestion,
                          attached: {
                            image: [
                              ...(suggestion.attached?.image ?? []).filter((f) => f.url !== deleteFile),
                              ...file.filter((f) => f.type === 'image' && !(suggestion.attached?.image ?? []).some((existing) => existing.url === f.url)).map((f) => ({ url: f.url, fileName: f.fileName, publicId: f?.publicId, id: f?.id })),
                            ],

                            video: [
                              ...(suggestion.attached?.video ?? []).filter((f) => f.url !== deleteFile),
                              ...file.filter((f) => f.type === 'video' && !(suggestion.attached?.video ?? []).some((existing) => existing.url === f.url)).map((f) => ({ url: f.url, fileName: f.fileName, publicId: f?.publicId, id: f?.id })),
                            ],

                            document: [
                              ...(suggestion.attached?.document ?? []).filter((f) => f.url !== deleteFile),
                              ...file.filter((f) => f.type !== 'image' && f.type !== 'video' && !(suggestion.attached?.document ?? []).some((existing) => existing.url === f.url)).map((f) => ({ url: f.url, fileName: f.fileName, publicId: f?.publicId, id: f?.id })),
                            ],
                          },
                        }
                      : suggestion,
                  ),
                },
              }
            : { ...accordion, children: updateNestedAccordion(accordion.children) },
        ) ?? accordionList

      return prevData?.accordions ? { ...prevData, accordions: updateNestedAccordion(prevData.accordions) } : prevData
    })
  }

  const renderAccordions = (list, index, isFirst) => {
    return (
      <div className=" ">
        <CRow>
          <div className="overflow-visible">
            {list?.map((item) => (
              <AccordianEditDelete
                isFirst={isFirst}
                handleAddTitleDescription={handleAddTitleDescription}
                title={item.title}
                accordion={item}
                editAccordion={editAccordion}
                deleteAccordion={deleteAccordion}
                setActiveDescriptions={setActiveDescriptions}
                file={file}
                setFile={setFile}
                parentId={item.id}
                handleTitleFileSave={handleTitleFileSave}
                type={'generalPlanStatements'}
                ApiCallingType={'generalPlanStatements'}
                setParentAccordions={setAccordions}
                handleTitleParentMediaId={handleTitleParentMediaId}
                differentModuleCopyFunctionality={true}
                content={
                  <div>
                    <div className="d-flex gap-2 justify-content-center" style={{ marginTop: '10px' }}>
                      {/* <CButton
                                            variant="outline"
                                            color="warning "
                                            onClick={() => openModal(item.id)}
                                            className="custom-button shadow-sm text-warning"
                                            style={{
                                                padding: "5px 10px",
                                                borderRadius: "20px",
                                                fontSize: "12px",
                                                fontWeight: "500",

                                            }}
                                        >
                                            <i className="bi bi-plus-circle me-1"></i>Add/Edit Title
                                        </CButton> */}
                      <CButton
                        variant="outline"
                        color=""
                        onClick={async () => {
                          // await SaveExtra('Insert', 'generalPlanStatements', JSON.stringify(accordions));

                          if (item.suggestions && !Array.isArray(item.suggestions) && item?.suggestions?.suggestionName.length > 0) {
                            item?.suggestions?.suggestionName?.map((s, index) => {
                              setSuggestionId(item.id)
                              setSuggestionModalVisible(true)
                              setSuggestionIndex(index)
                              setEditMode(true)
                              setSuggestionTitle(() => {
                                let data = item?.suggestions?.suggestionName
                                return data
                              })
                            })
                          } else {
                            setSuggestionId(item.id)
                            setSuggestionModalVisible(true)
                          }
                        }}
                        className="custom-button shadow-sm general-plan-statements-theme__statement-button"
                        style={{
                          padding: '5px 10px',
                          borderRadius: '20px',
                          fontSize: '12px',
                          fontWeight: '500',
                        }}
                      >
                        <i className="bi bi-lightbulb me-1"></i>Add/Edit Statements
                      </CButton>
                    </div>

                    {item.suggestions && (
                      <ul className="list-group mt-4 mx-4 general-plan-statements-theme__suggestion-list">
                        <DifferentialSuggestion
                          suggestions={item?.suggestions?.suggestionName}
                          parentId={item.id}
                          handleAddStatementDescription={handleAddStatementDescription}
                          isStatementBox={false}
                          onSuggestionsChange={handleSuggestionsChange}
                          setSaveResoanChange={setSaveResoanChange}
                          submitDescription={submitDescription}
                          setSubmitDescription={setSubmitDescription}
                          setActiveDescriptions={setActiveDescriptions}
                          handleFileStatementData={handleFileStatementData}
                          handleStatementFileSave={handleStatementFileSave}
                          fileStatmentData={fileStatmentData}
                          file={file}
                          setFile={setFile}
                          descriptionStatementId={descriptionStatementId}
                          setParentAccordions={setAccordions}
                          showTab={true}
                          activeDescriptions={activeDescriptions}
                          ApiCallingType={'generalPlanStatements'}
                        />
                      </ul>
                    )}

                    {item.children.length > 0 && <div className="mt-4">{renderAccordions(item.children, index, true)}</div>}
                  </div>
                }
              />
            ))}
          </div>
        </CRow>
      </div>
    )
  }

  const editDifferentialDiagnosis = (item) => {
    setShowEditModal(true)
    setSelectedDiagnosis(item)
  }

  const handleDeleteInsideData = (item) => {
    setSelectedDiagnosis(item)
    setDeleteModal(true)
  }

  const handleDeleteDataModal = async () => {
    if (accordions) {
      let accordionsData = {
        ...accordions,
        accordions: [],
      }

      let SuggestionData = suggestionData.filter((item) => item?.Data?.diagnosis?.value === selectedDiagnosis.value)
      await SaveExtra('Update', 'generalPlanStatements', JSON.stringify(accordionsData), SuggestionData[0].Id)
      await getData()
      setDeleteModal(false)
      setSelectedDiagnosis(null)
    } else {
      toast('No Accordion Present In List Of Current Selected Diagnosis')
    }
  }

  const handelAutoSubmit = async () => {
    setIsLoading(true)
    try {
      if (LinkFor == 'generalPlanStatements') {
        if (!selectedDiagnosis) {
          alert('Please select a diagnosis.')
          return
        }

        let localData = JSON.parse(localStorage.getItem('SuggestionDiagnosis')) || []
        let SuggestionData = suggestionData.filter((item) => item?.Data?.diagnosis?.value === selectedDiagnosis.value)
        if (SuggestionData.length > 0) {
          await SaveExtra('Update', 'generalPlanStatements', JSON.stringify(accordions), SuggestionData[0].Id)
        } else {
          await SaveExtra('Insert', 'generalPlanStatements', JSON.stringify(accordions))
        }
        setSaveResoanChange({})
        getData()
        fetchData()
      } else if (LinkFor == 'HPI') {
        setLinkData(accordions)
      }
    } catch (error) {
      console.log(error)
    } finally {
      setIsLoading(false)
    }
  }

  const handleDeleteData = (parentId) => {
    setAccordions((prev) => {
      const updatedAccordions = removeAccordionById(prev.accordions, parentId)
      const updatedData = { ...prev, accordions: updatedAccordions }
      return updatedData
    })
    setDeleteVisibleId(null)
  }

  return (
    <>
      <div>
        <CModal size="xl" visible={showEditModal} backdrop="static" className="patient-theme-modal general-plan-statements-theme__split-modal">
          <div>
            <div>
              <div className="d-flex justify-content-between border-bottom general-plan-statements-theme__split-header">
                <p className="p-2 m-0 text-center w-50 border-end general-plan-statements-theme__split-heading" style={{ fontWeight: '600' }}>
                  Statement
                </p>
                <p className="p-2 m-0 text-center w-50 general-plan-statements-theme__split-heading" style={{ fontWeight: '600' }}>
                  Description
                </p>
              </div>
              <motion.div className="general-plan-statements-theme__split-shell" initial={{ opacity: 0 }} animate={{ opacity: 1 }} transition={{ duration: 0.5 }} style={{ height: '70vh', overflow: 'auto' }}>
                <div className="d-flex flex-column h-100 ">
                  <div className="d-flex flex-grow-1 h-100">
                    <CCol className="d-flex flex-column align-items-center justify-content-start gap-2 border-end p-3 general-plan-statements-theme__split-pane general-plan-statements-theme__split-pane--left" style={{ width: '50%', overflowY: 'auto', height: '100%' }}>
                      <div className=" w-100" style={{ height: '100%' }}>
                        {renderAccordions(accordions?.accordions)}
                      </div>
                    </CCol>

                    <CCol className="d-flex flex-column p-3 general-plan-statements-theme__split-pane general-plan-statements-theme__split-pane--right" style={{ width: '50%', overflowY: 'auto', height: '100%' }}>
                      {activeDescriptions && (
                        <div>
                          <div className="pe-tab-underline-nav mb-4">
                            <CNav role="tablist" className="justify-content-center">
                              <CNavItem>
                                <CNavLink active={activeTab === 0} onClick={() => setActiveTab(0)}>
                                  New
                                </CNavLink>
                              </CNavItem>
                              <CNavItem>
                                <CNavLink
                                  active={activeTab === 1}
                                  onClick={() => {
                                    setActiveTab(1)
                                    handelSubmit(false)
                                  }}
                                >
                                  Copy
                                </CNavLink>
                              </CNavItem>
                            </CNav>
                          </div>
                          <div activeTab={activeTab} onActiveTabChange={setActiveTab}>
                            <CTabContent>
                              {activeTab === 0 && (
                                <CTabPane visible={activeTab === 0}>
                                  {activeDescriptions == 'statement' && (
                                    <div>
                                      <div className="mx-5">
                                        <CFormTextarea
                                          id="descriptionTextarea"
                                          label="Enter your description"
                                          style={{ height: '400px', color: '#ffc107', caretColor: 'black' }}
                                          className="form-control general-plan-statements-theme__textarea"
                                          placeholder="Type your description here..."
                                          value={descriptionStatementText}
                                          onChange={(e) => {
                                            setDescriptionStatementText(e.target.value)
                                          }}
                                        />
                                      </div>

                                      <div className=" mx-5 my-2 m-0 d-flex justify-content-end">
                                        <CButton onClick={handleDescriptionStatementSubmit} className="ui-action-btn ui-action-btn--primary">
                                          Save Description
                                        </CButton>
                                        {/* <CButton
                                                                    onClick={() => {
                                                                        setShowDescriptionStatementModal(false);
                                                                        setDescriptionStatementId({
                                                                            orderIndex: "",
                                                                            parentId: "",
                                                                        })
                                                                    }}
                                                                    variant='outline' color="secondary" >Close</CButton> */}
                                      </div>
                                    </div>
                                  )}
                                  {activeDescriptions == 'title' && (
                                    <div>
                                      <div className="mx-5">
                                        <CFormTextarea
                                          style={{ height: '400px', color: '#ffc107', caretColor: 'black' }}
                                          className="form-control general-plan-statements-theme__textarea"
                                          value={descriptionText}
                                          onChange={(e) => {
                                            setDescriptionText(e.target.value)
                                          }}
                                          placeholder="Enter Description"
                                        ></CFormTextarea>
                                      </div>
                                      <div className="mx-5 my-2 m-0 d-flex justify-content-end">
                                        {/* <CButton variant="outline" color="secondary" onClick={() => setTitleDescriptionId("")}>
                                                                        Close
                                                                    </CButton> */}
                                        <CButton onClick={handleSaveDescription} className="ui-action-btn ui-action-btn--primary">
                                          Save Description
                                        </CButton>
                                      </div>
                                    </div>
                                  )}
                                </CTabPane>
                              )}
                              {activeTab === 1 && (
                                <CTabPane visible={activeTab === 1} className=" d-flex flex-column  justify-content-center align-items-center">
                                  <div className="w-100 rounded general-plan-statements-theme__copy-surface differential-copy-theme" style={{ height: '200px' }}>
                                    <DifferentialCopy
                                      setDescriptionStatementText={setDescriptionStatementText}
                                      setActiveTab={setActiveTab}
                                      descriptionStatementId={descriptionStatementId}
                                      setParentAccordions={setAccordions}
                                      ApiCallingType={'generalPlanStatements'}
                                      parentId={currentParentId}
                                      setSuggestionModalVisible={setSuggestionModalVisible}
                                      type={'generalPlanStatements'}
                                      differentModuleCopyFunctionality={true}
                                    />
                                  </div>
                                </CTabPane>
                              )}
                            </CTabContent>
                          </div>
                        </div>
                      )}
                    </CCol>
                  </div>
                </div>
              </motion.div>
            </div>
            {/* <div className=" p-2" style={{ height: '75vh', overflow: 'auto', width: '100vw' }}>

                        {renderAccordions(accordions?.accordions)}
                    </div> */}
          </div>
          <hr />
          <div className=" text-end d-flex justify-content-end  gap-2  m-2 pb-2 ">
            <CButton
              onClick={() => {
                handelSubmit()
              }}
              className="px-4 ui-action-btn ui-action-btn--secondary"
            >
              Save
            </CButton>
            <CButton
              onClick={async () => {
                await handelSubmit()
                setSelectedDiagnosis(null)
                setShowEditModal(false)
                setActiveDescriptions(null)
              }}
              className="px-4 ui-action-btn ui-action-btn--primary"
            >
              Save & Close
            </CButton>
            <CButton
              color="secondary"
              onClick={() => {
                setSelectedDiagnosis(null)
                setShowEditModal(false)
                setActiveDescriptions(null)
              }}
              className="px-4 ui-action-btn ui-action-btn--secondary"
            >
              Close
            </CButton>
          </div>
        </CModal>

        <CModal
          size="lg"
          visible={modalVisible}
          className="patient-theme-modal"
          onClose={() => {
            setModalVisible(false)
            setAssessment([])
            setPlans([])
            setNewTitle('')
          }}
        >
          <CModalHeader
            onClose={() => {
              setModalVisible(false)
              setAssessment([])
              setPlans([])
              setNewTitle('')
            }}
          >
            <CModalTitle>{editMode ? 'Edit Title' : 'Add Title'}</CModalTitle>
          </CModalHeader>
          <CModalBody>
            {modalVisible && (
              <>
                {/* <div className="border mt-0 p-2 py-4 rounded">
                                    <div className='w-100'>
                                        <p className='font-weight-large mb-2' style={{ fontSize: '13px' }}>Header</p>
                                        <CFormInput
                                            name='Title'
                                            value={newTitle}
                                            onChange={(e) => setNewTitle(e.target.value)}
                                            type='text'
                                            placeholder=''
                                            className='h-25'
                                        />
                                    </div>
                                </div> */}
                <div className="mt-0 p-2 rounded  ">
                  <AddSuggestionTitle
                    handleSubmitWhenTabChange={handelSubmit}
                    ApiCallingType={'generalPlanStatements'}
                    newTitle={newTitle}
                    setNewTitle={setNewTitle}
                    setParentAccordions={setAccordions}
                    parentId={currentParentId}
                    handelAutoSubmit={handelAutoSubmit}
                    setModalVisible={setModalVisible}
                    addAccordion={addAccordion}
                    LinkFor={LinkFor}
                    differentModuleCopyFunctionality={true}
                    accordions={accordions}
                    showOrderTab={false}
                    setShowTitleFooter={setShowTitleFooter}
                  />
                </div>
              </>
            )}
          </CModalBody>
          {showTitleFooter && (
            <>
              <hr />
              <CModalFooter>
                <CButton
                  color="secondary"
                  className="ui-action-btn ui-action-btn--secondary"
                  onClick={() => {
                    setModalVisible(false)
                    setKeywords([])
                    setPlans([])
                    setNewTitle('')
                    setEditingAccordionId(null)
                  }}
                >
                  Close
                </CButton>
                <CButton color="primary" className="ui-action-btn ui-action-btn--primary" onClick={() => addAccordion(currentParentId)}>
                  {isLoading ? (
                    <>
                      <CSpinner component="span" size="sm" variant="grow" aria-hidden="true" />
                      Loading...
                    </>
                  ) : editMode ? (
                    'Edit '
                  ) : (
                    'Save '
                  )}
                </CButton>
              </CModalFooter>
            </>
          )}
        </CModal>

        <CModal
          size="lg"
          backdrop="static"
          visible={suggestionModalVisible}
          className="patient-theme-modal general-plan-statements-theme__modal"
          onClose={() => {
            setSuggestionModalVisible(false)
            setSuggestionTitle([])
            setEditMode(false)
          }}
        >
          <CModalHeader
            onClose={() => {
              setSuggestionModalVisible(false)
              setSuggestionTitle([])
              setEditMode(false)
            }}
          >
            <CModalTitle>{isEditing ? 'Edit Suggestion' : 'Add Statements'}</CModalTitle>
          </CModalHeader>
          <CModalBody>
            {suggestionModalVisible && (
              <>
                {/* <div className=" mt-0 p-2 py-4 rounded">
                                    <div className='w-100'>
                                        <div className="w-100 p-3 border rounded shadow-sm bg-light">
                                            <ReasonSuggestion className='mb-3' label='Suggestion' keywords={suggestionTitle} setKeywords={setSuggestionTitle} />
                                        </div>

                                    </div>
                                </div> */}
                <div className=" mt-0 p-2 py-4 rounded general-plan-statements-theme__copy-surface">
                  <div className="w-100">
                    <div className="w-100 p-3 rounded pe-title-card general-plan-statements-theme__suggestion-panel">
                      <AddCopyStatement
                        className="mb-3"
                        type={'generalPlanStatements'}
                        label="Statement"
                        handleSubmitWhenTabChange={handelSubmit}
                        keywords={suggestionTitle}
                        setKeywords={setSuggestionTitle}
                        setParentAccordions={setAccordions}
                        parentId={suggestionId}
                        setSuggestionModalVisible={setSuggestionModalVisible}
                        differentModuleCopyFunctionality={true}
                      />
                    </div>
                  </div>
                </div>
              </>
            )}
          </CModalBody>

          <CModalFooter>
            <CButton
              color="secondary"
              className="ui-action-btn ui-action-btn--secondary"
              onClick={() => {
                setSuggestionModalVisible(false)
                setSuggestionTitle([])
                setEditMode(false)
              }}
            >
              Close
            </CButton>
            <CButton
              color="primary"
              className="ui-action-btn ui-action-btn--primary"
              onClick={() => {
                ;(setSuggestionModalVisible(false), editMode ? editSuggestion(suggestionId, suggestionIndex) : addSuggestion(suggestionId), setActiveDescriptions(''))
              }}
            >
              {isLoading ? (
                <>
                  <CSpinner component="span" size="sm" variant="grow" aria-hidden="true" />
                  Loading...
                </>
              ) : (
                'Save '
              )}
            </CButton>
          </CModalFooter>
        </CModal>

        <CModal backdrop="static" visible={deleteModal} className="patient-theme-modal">
          <CModalHeader>
            <CModalTitle>Warning</CModalTitle>
          </CModalHeader>
          <CModalBody>
            <p className="fs-6 p-0 m-0">Are you sure you want to delete?</p>
          </CModalBody>
          <hr className="p-0 m-0" />
          <CModalFooter className="p-3 m-0">
            <CButton
              onClick={() => {
                setSelectedDiagnosis(null)
                setDeleteModal(false)
              }}
              color="secondary"
              className="ui-action-btn ui-action-btn--secondary"
            >
              Close
            </CButton>
            <CButton onClick={handleDeleteDataModal} className="ui-action-btn ui-action-btn--delete">
              Delete
            </CButton>
          </CModalFooter>
        </CModal>
        <Pageloader isLoading={isPageLoading} />

        <CModal backdrop="static" visible={deleteVisibleId} className="patient-theme-modal">
          <CModalHeader>
            <CModalTitle>Warning</CModalTitle>
          </CModalHeader>
          <CModalBody>
            <p className="fs-6 p-0 m-0">Are you sure you want to delete?</p>
          </CModalBody>
          <hr className="p-0 m-0" />
          <CModalFooter className="p-3 m-0">
            <CButton
              onClick={() => {
                setDeleteVisibleId(null)
              }}
              color="secondary"
              className="ui-action-btn ui-action-btn--secondary"
            >
              Close
            </CButton>
            <CButton onClick={() => handleDeleteData(deleteVisibleId)} className="ui-action-btn ui-action-btn--delete">
              Delete
            </CButton>
          </CModalFooter>
        </CModal>
      </div>

      <div>
        <div className="merge-suggestions-theme" style={{ height: '100vh', overflow: 'auto' }}>
          <CRow className="p-2">
            {diagnosisOptions.map((item, index) => {
              let dataStatus = suggestionData.filter((suggestion) => suggestion.Data.diagnosis.value === item.value && suggestion.Data.accordions.length > 0)
              return (
                <CCol xs={4} key={index}>
                  <ListView
                    heading={item.label}
                    editFunc={() => editDifferentialDiagnosis(item)}
                    deleteFunc={() => {
                      handleDeleteInsideData(item)
                    }}
                    // viewFunc={() => handleView(item)}
                    contentMatch={dataStatus.length > 0 ? true : false}
                    setSelectedDiagnosis={setSelectedDiagnosis}
                    // subheading={ }
                  ></ListView>
                </CCol>
              )
            })}
          </CRow>
        </div>
      </div>
    </>
  )
}

export default Generalplanstatements
